<template>

  <div>
    <!-- product Modal -->
    <b-modal
        v-model="showModalInternal"
        id="product-select-modal-form"
        scrollable
        title="Baza towarów centralnych"
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer


    >
      <div v-if="showModalInternal">

        <ProductDataList ref="productDataList"
            :multiselect="multiselect" @onSelect="selectProducts"
                         @onSelectRow="selectProduct($event)"
                         :showRowActions="showRowActions"
                         :showMassActions="showMassActions"
                         :selectedProducts="selectedProductsData"
                         :showAddButton="showAddButton"
                         :disableInitiallyCheckedItems="disableInitiallyCheckedItems"
                         :ignoreInitiallyCheckedItems="ignoreInitiallyCheckedItems"
                         :visibleColumnsFilter="visibleColumnsFilter"
                         :enableRowSelection="enableRowSelection"
                         :showCheckboxColumn="showCheckboxColumn"
        >

          <template #bottom>
            <div class="modal-footer-container">
              <div class="modal-footer-bottom">
                <button class="btn btn-primary" @click="applySelectProduct" :disabled="!selectedProducts || selectedProducts.length === 0">{{ okTitle }}</button>
              </div>

            </div>

          </template>

        </ProductDataList>
      </div>




    </b-modal>
  </div>



</template>
<script>
import {defineComponent} from 'vue'
import {BModal} from "bootstrap-vue-next";
import ProductDataList from "./ProductDataList.vue";
export default defineComponent({
  name: "ProductListModal",
  props: {
    showModal:{
      type: Boolean,
      required: true
    },
    multiselect: {
      type: Boolean,
      default: true,
    },
    showMassActions: {
      type: Boolean,
      default: () => true
    },
    showRowActions: {
      type: Boolean,
      default: () => true
    },
    showAddButton: {
      type: Boolean,
      default: () => true
    },
    selectedProductsData: {
      type: Array,
      default: () => []
    },
    okTitle:{
      type:String,
      required:false
    },
    resetSelectionAfterApply:{
      type:Boolean,
      default: () => false
    },
    disableInitiallyCheckedItems: {type: Boolean, default: () => false},
    ignoreInitiallyCheckedItems: {type: Boolean, default: () => false},
    visibleColumnsFilter:{ // declare only columns keys You want to see
      type:Array,
      default: ()=>[]
    },
    enableRowSelection: {
      type: Boolean,
      default: () => true
    },
    showCheckboxColumn: {
      type: Boolean,
      default: () => true
    },
  },
  emits: ["update:showModal","onApply","onClose"],
  components: {ProductDataList, BModal},
  data(){
    return {
      showModalInternal:this.showModal,
      selectedProducts:null,
    }
  },
  methods:{
    selectProducts(itemsData){
      this.selectedProducts = itemsData
    },
    selectProduct(product){
      this.selectedProducts = [product]
    },
    applySelectProduct(){
      this.$emit("onApply",this.selectedProducts)
      if(this.resetSelectionAfterApply){
        this.selectedProducts = null;
       this.$refs.productDataList.resetSelectedProducts();
      }
    },
    closeModal(){
      this.showModalInternal = false
      this.$emit("onClose")
    }
  },
  watch:{
    // Watch parent prop changes and sync
    showModal(newValue) {
      this.showModalInternal = newValue;
    },
    // Watch local copy and emit to parent
    showModalInternal(newValue) {
      this.$emit('update:showModal', newValue);
    }
  },
})
</script>
<style scoped>
.modal-footer-container {
  position: sticky;
  bottom: -19px;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 60;
  padding: 0;
}

.modal-footer-bottom {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 24px;
}
</style>
